export class UpdateServiceQueuePipelineContentDto {
  PipelineId: number;
  IsForQueue: boolean;
  Services: UpdateServiceQueuePipelineServiceDto[];
}

export class UpdateServiceQueuePipelineServiceDto {
  /**
   * The unique identifier of the service.
   */
  ServiceId: number;
  /**
   * The new order of the service in the pipeline.
   */
  SortIndex: number;
}
